


const GET_SIGNED_URL_PATH = "get-data-access"
const UPLLOAD_FILE_URL_PATH = "upload-file"
const PAYMENT_CHECKOUT_URL_PATH = "payments/checkout"
const PAYMENT_PRODUCT_CHECKOUT_URL_PATH = "payments/product-checkout"
const ORGANIZATION_DASHBOARD_URL_PATH = "payments/express-dashboard"
const PAYMENT_CUSTOMER_PORTAL_URL_PATH = "payments/customer-portal"
const ORGANIZATION_ACCOUNT_URL_PATH = "payments/organization-account"
const ORGANIZATION_DEPOSIT_URL_PATH = "payments/deposit"
export {
    GET_SIGNED_URL_PATH,
    UPLLOAD_FILE_URL_PATH,
    PAYMENT_CHECKOUT_URL_PATH,
    PAYMENT_CUSTOMER_PORTAL_URL_PATH,
    ORGANIZATION_ACCOUNT_URL_PATH,
    PAYMENT_PRODUCT_CHECKOUT_URL_PATH,
    ORGANIZATION_DEPOSIT_URL_PATH,
    ORGANIZATION_DASHBOARD_URL_PATH
}